/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { LoadingComponent, LoginSecurityComponent, MyProfileComponent, MyUserNamesComponent, NavigationComponent } from '../../components';
import '../../common/theme/ProfileTheme.scss';
import './AccountPrefPage.scss';

export default function AccountPrefPage({ refreshToken, accountInfo, contactInfo, scrollToTop, setNavItem, prefPage, openGlobalBanner }) {
  const loading = useSelector(state => state.loading);
  const userNames = useSelector(state => state.enrollments);

  useEffect(() => {
    scrollToTop();
  }, [contactInfo]);

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <Box className='accountpref agent-ciam-container'>
      <Box className='accountpref-content'>
        <Box className='account-pref-title'>Account preferences</Box>
        <Box className='accountpref-container'>
          <NavigationComponent userNames={userNames} onItemClick={setNavItem} selectedNavItem={prefPage}/>
          {prefPage === 'MyProfile' && <MyProfileComponent contactData={contactInfo}/>}
          {prefPage === 'LoginSecurity' && <LoginSecurityComponent contactData={contactInfo} accountInfo={accountInfo}/>}
          {prefPage === 'MyUserNames' &&  userNames.length > 0 && ( <MyUserNamesComponent userNames={userNames} refreshToken={refreshToken} setNavItem={setNavItem} openGlobalBanner={openGlobalBanner}/> )}
        </Box>
      </Box>
    </Box>
  );
}
